export default {
    placeOrder: (data) => window.axios.post('place_order', data),
    viewOrderDetails: (data) => window.axios.post('view_order_details', data),
    getOrderStatus: (data) => window.axios.post('get_order_status', data),
    addOrderRating: (data) => window.axios.post('add_rating', data),
    checkRating: (data) => window.axios.post('check_rating', data),
    reorderDetails: (data) => window.axios.post('reorder_details', data),
    trackOrderCustomer: (data) => window.axios.post('track_of_driver_customer', data),
    uploadOrderImages: (data) => window.axios.post('upload-order-images', data),
    removeOrderImages: (data) => window.axios.post('remove-order-image', data),
    getOrderDistance: (data) => window.axios.post('get-order-distance', data),
    postOrderPreBooking: (data) => window.axios.post('order/pre_booking', data),
    getOrderPreBookingList: (data) => window.axios.post('order/pre_booking_list', data),
    postPaymentMethod: (data) => window.axios.post('post_payment_method', data),
    getChowmanPayHistory: (data) => window.axios.post('chowman_pay/history', data),
    chowmanPayCreate: (data) => window.axios.post('chowman_pay/create', data),
    chowmanPayOrderDetails: (data) => window.axios.post('chowman_pay/details', data),
    OnGoingOrders: (data) => window.axios.post('ongoing_orders', data),
    PastOrders: (data) => window.axios.post('order_history', data),
    getOrderListWithBooking: (data) => window.axios.post('new_order_list_with_booking', data),
    newOrderList: (data) => window.axios.post('new_order_list', data),
    getOrderInvoice: (data) => window.axios.get('order-invoice', {params:data}),
    downloadOrderInvoicePDF: (data) => window.axios.get('order-invoice', {params:data, responseType: 'blob'}),
}